export const config = {
	apiKey: "AIzaSyC2j_hAByxwz9sd2ncDAaMoASSxmRJl0XU",
	authDomain: "swipe-app-welgelegen.firebaseapp.com",
	projectId: "swipe-app-welgelegen",
	storageBucket: "swipe-app-welgelegen.appspot.com",
	messagingSenderId: "880476317859",
	appId: "1:880476317859:web:81de5283eb3c57a162b716",
};
